export default __webpack_public_path__ + "static/media/talent-sourcers.8e9558f1.svg";